import React from "react";
import ReactDOM from "react-dom";
//
// import Filepond from "./filepond";
import CouImageFields from "./cou-image-fields";
// import Coufigure from "./cou-figure";
//
const mounter = ({ el, name, ...props }) => {
  switch (name) {
    // case "coufigure":
    //   ReactDOM.render(<Coufigure {...props} />, el);
    //   break;

    case "couimagefields":
      ReactDOM.render(<CouImageFields {...props} />, el);
      break;

    // case "filepond":
    //   ReactDOM.render(<Filepond {...props} />, el);
    //   break;

    default:
      console.log("Unknown React Component:", name);
      break;
  }
};

export const mountReactComponents = () => {
  const componentElements = document.querySelectorAll("[data-react-component]");

  for (var i = 0; i < componentElements.length; i++) {
    const el = componentElements[i];
    const name = el.getAttribute("data-react-component");
    const props = JSON.parse(el.dataset.props);

    mounter({ el, name, ...props });
  }
};
